/* Important Info component on the CharactersAdd component
   telling users how to add Characters */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const Info = () => {
  return (
    <div>
    <Row className="my-3">
      <Col className="d-none d-md-block" md={1}></Col>     
      <Col xs={12} md={10} >
        <div className={`px-3 py-2 text-center ${styles.SubTitle6 }`}>
          <p className={`${styles.Red} text-center`}>DRAG AND DROP INFO</p>
          <hr className={`mt-2 mb-0`}/>
        <p className='mt-2'> <span className={`${styles.Red}`}>*</span> Use Drag and Drop to <span className={`${styles.Red}`}>reorder</span> Scenes </p>
        <p><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Quick Edit</span> button 
                    to quickly update the Start Time and Next values.
                </p>
        <hr className={`mt-2 mb-0`}/>
         </div>
      </Col>
    </Row>
    </div>
  )
}

export default Info